import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonService } from 'src/app/services/common.service';
import { TooltipService } from 'src/app/services/tooltip.service';
import { ICellRendererParams } from 'ag-grid-community';
import { isFor } from '@babel/types';

interface CategoryData {
  code: string;
  description: string;
}

@Component({
  selector: 'vrm-licence-categories-tooltips',
  template: `<div class="cell-values">
    <span *ngIf="isForeignLicence">N/A</span>
    <div *ngIf="!isForeignLicence">
      <span
        class="cell-value"
        (mouseenter)="displayCategory($event.target, category.code, category.description)"
        (mouseleave)="hideCategory()"
        *ngFor="let category of categories"
      >
        {{ category.code }}
      </span>
    </div>
  </div>`,
  styles: [],
})
export class LicenceCategoriesTooltipsComponent implements ICellRendererAngularComp {
  public isForeignLicence = false;
  public categories: CategoryData[];

  constructor(private tooltipService: TooltipService, private translation: TranslateService) {}

  public agInit(params: ICellRendererParams) {
    this.categories = params.data['categoryDescriptions'];
    this.isForeignLicence = params.value === 'N/A';
  }

  public displayCategory(targetElement: any, code: string, description: string): void {
    this.translation.get('LICENCE_CHECKING').subscribe({
      next: (translate) => {
        this.tooltipService.setContent({
          title: `${translate.code} ${code}`,
          description: description,
        });
        this.tooltipService.displayRelativeTo(targetElement);
      },
    });
  }

  public hideCategory(): void {
    this.tooltipService.hide();
  }

  public refresh(): boolean {
    return false;
  }
}
